import React from "react";
import classes from "./PageSummary.module.css";

const DsearSummary = () => {
  return (
    <section className={classes.summary}>
      <h2 style={{ fontWeight: "bold" }}>
        Welcome to the @one Alliance Engineering DSEAR Register
      </h2>
      <p>
        Here you can submit projects with DSEAR Zones to be kept on a central
        register.
      </p>
      {/* <p></p> */}
      {/* <p>
        This area is currently under development and more releases are planned
        over the coming weeks and months. Please check back regularly for new
        updates and look out for communications coming your way.
      </p> */}
      <p>
        For all questions, or to tell us what you think, please contact
        oneengineering@anglianwater.co.uk
      </p>
    </section>
  );
};

export default DsearSummary;
